import { render } from "./handsComponent.vue?vue&type=template&id=1b3125db&scoped=true"
import script from "./handsComponent.vue?vue&type=script&lang=js"
export * from "./handsComponent.vue?vue&type=script&lang=js"

import "./handsComponent.vue?vue&type=style&index=0&id=1b3125db&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3125db"]])

export default __exports__